import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  payload: any;
  id: string;
  title: string;
  body: string;
  field_common_malay_description: string;
  field_common_malay_title: string;
  field_common_mandarin_descriptio: string;
  field_common_mandarin_title: string;
  published: boolean;
  field_store_location: { id: string; name: string }[];
  field_food_bev_airport: { id: string; name: string; publish?: boolean }[];
  field_common_image: string[];
  field_banner_image: string;
  field_brands: any[];
  field_food_and_beverage_types: string;
  field_food_category: string;
  field_user_type: string;
}

// Edit API call
const fetchOutletDetails = async (id: string): Promise<DocumentDetailsResponse | null> => {
  if (!id) return null;

  const response = await eramanCMSApi.get(`/api/all-food-and-beverages-data-list/${id}`);

  const outletData = response?.data?.data?.[0];
  if (!outletData) {
    throw new Error("Outlet not found");
  }

  return outletData;
};

const useOutletDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["outletDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchOutletDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useOutletDocumentDetails };
